import * as React from 'react';

import { getConstantQueryFetchPaged } from '../../../helpers/constants';
import { DataStorage } from '../../../helpers/utils/DataStorage';
import { SystemObjectTypeVals } from '../../../helpers/constants/modelValues/SystemObjectTypeVals';
import { NotesPager, NotesPaging } from '../../notes/components/NotesPager';
import { PDFNoteStatusVals } from '../../../helpers/mapping/PDFNoteStatusVals';
import { PDFNoteQuery } from '../../notes/models/PDFNoteQuery';
import { ProjectDoc } from '../../projectDocs/models/ProjectDoc';
import { NoteUpdatesController } from '../../notes/helpers/noteUpdates';

interface NotesProps {
    type: 'Recived' | 'Completed' | 'Archived';
    projectDocFolderId: number;
    projectDocFolderStatusId: number;
    projectDoc?: ProjectDoc;
    dataStorage: DataStorage;
    setDataStorageValue: (key: string, value: any) => void;
    onNoteChanged: () => void;
    noteUpdates?: NoteUpdatesController;
    paging?: NotesPaging;
}

const getActivePDFNoteQuery = (query: PDFNoteQuery): PDFNoteQuery => ({
    ...query,
    IsDeleted: false,
    IncludeDeletedWorkflowInstances: false
});

export const Notes: React.FC<NotesProps> = ({
    type,
    projectDocFolderId,
    projectDocFolderStatusId,
    projectDoc,
    dataStorage,
    setDataStorageValue,
    onNoteChanged,
    noteUpdates,
    paging
}) => {
    const initialQueryKey: string = `Notes_${type}`;

    var statusIds: number[] = [];

    switch (type) {
        case 'Recived':
            statusIds = [PDFNoteStatusVals.GIPApproved, PDFNoteStatusVals.Guarantee, PDFNoteStatusVals.NotCompleted];
            break;
        case 'Completed':
            statusIds = [PDFNoteStatusVals.Completed];
            break;
        case 'Archived':
            statusIds = [PDFNoteStatusVals.CompletionConfirmed];
            break;
        default:
            break;
    }
    const [initialQuery, setInitialQuery] = React.useState<PDFNoteQuery>(
        getActivePDFNoteQuery(
            normalizeQueryForFolder(dataStorage.get<PDFNoteQuery>(initialQueryKey, {
                ...getConstantQueryFetchPaged(),
                NoteObjectIds: [projectDocFolderId],
                SystemObjectTypeId: SystemObjectTypeVals.Folder,
                AssigneeIds: [],
                WorkflowInstanceIds: [],
                TaskIds: [],
                NotTaskIds: [],
                CodeIds: [],
                StatusIds: statusIds,
                NotStatusIds: [],
                Sorts: [{ Field: 'Id', Desc: true }],
                RequireCompletedTask: type === 'Recived' ? true : undefined
            }))
        )
    );

    function normalizeQueryForFolder(query: PDFNoteQuery): PDFNoteQuery {
        return noteUpdates ? {
            ...query,
            NoteObjectIds: [projectDocFolderId],
            StatusIds: statusIds,
            RequireCompletedTask: type === 'Recived' ? true : undefined,
        } : query;
    }

    React.useEffect(
        () => {
            if (projectDocFolderId === 0) return;

            setInitialQuery(
                getActivePDFNoteQuery({
                    ...initialQuery,
                    NoteObjectIds: [projectDocFolderId],
                    StatusIds: statusIds,
                    RequireCompletedTask: type === 'Recived' ? true : undefined
                })
            );
        },
        // eslint-disable-next-line
        [projectDocFolderId]
    );

    return (
        <NotesPager
            dataStorage={dataStorage}
            setDataStorageValue={setDataStorageValue}
            initialQueryName={initialQueryKey}
            initialQuery={initialQuery}
            projectDocFolderStatusId={projectDocFolderStatusId}
            projectDoc={projectDoc}
            requestEnable={initialQuery.NoteObjectIds.length > 0 && initialQuery.NoteObjectIds[0] > 0}
            onNoteChanged={onNoteChanged}
            type={type}
            {...(noteUpdates ? { noteUpdates } : {})}
            {...(paging ? { paging } : {})}
        />
    );
};
